export default function () {
  if (document.querySelector('.create-offer') !== null) {
    // eslint-disable-next-line no-unused-expressions
    import(/* webpackChunkName: "create-offer" */ './create-offer/main');
  }
}
